import BlTimelineMv from './BlTimelineMv.vue'

BlTimelineMv.install = function(Vue) {
  Vue.component(BlTimelineMv.name, BlTimelineMv)
}

export default BlTimelineMv
